import produce from 'immer';
import { AnyAction } from 'redux';
import {
  GET_CLUB_OPTIONS_REQUEST,
  GET_CLUB_OPTIONS_SUCCESS,
  GET_CLUB_OPTIONS_FAILURE,
  GET_CLUB_OPTIONS_INITIAL,
} from '../../actions';

/**
 * エリア(地域)の型定義
 */
export type RegionType = {
  region_id: number;
  region_name: string;
};

/**
 * タグの型定義
 */
export type TagType = {
  tag_id: number;
  tag_name: string;
  tag_manage: number; // 1: 施設・設備, 2: サービス
  order_no: number;
};

/**
 * 店舗検索オプションデータの型定義
 */
export type ClubOptionsDataType = {
  result: number; // 0:成功, 1:失敗
  region_list: RegionType[];
  tag_list: TagType[];
};

/**
 * Reservationステートの型定義
 */
export type ReservationStateType = {
  // 店舗検索オプション取得の状態
  isClubOptionsLoading: boolean;
  isClubOptionsLoaded: boolean;
  clubOptionsFailureMessage: string;
  clubOptionsData: ClubOptionsDataType;
};

/**
 * 初期状態
 */
const initialState: ReservationStateType = {
  isClubOptionsLoading: false,
  isClubOptionsLoaded: false,
  clubOptionsFailureMessage: '',
  clubOptionsData: {
    result: 0,
    region_list: [],
    tag_list: [],
  },
};

/**
 * Reservation Reducer
 * APIの結果によってステートが更新される処理
 */
const reservationReducer = (state = initialState, action: AnyAction): ReservationStateType => {
  return produce(state, (draft) => {
    const dataState = draft;
    switch (action.type) {
      // 店舗検索オプション取得 - リクエスト
      case GET_CLUB_OPTIONS_REQUEST:
        console.log('[reservationReducer] GET_CLUB_OPTIONS_REQUEST');
        dataState.isClubOptionsLoading = true;
        dataState.isClubOptionsLoaded = false;
        dataState.clubOptionsFailureMessage = '';
        dataState.clubOptionsData.result = 0;
        dataState.clubOptionsData.region_list = [];
        dataState.clubOptionsData.tag_list = [];
        break;

      // 店舗検索オプション取得 - 成功
      case GET_CLUB_OPTIONS_SUCCESS:
        console.log('[reservationReducer] GET_CLUB_OPTIONS_SUCCESS', action.res.data);
        dataState.isClubOptionsLoading = false;
        dataState.isClubOptionsLoaded = true;
        dataState.clubOptionsFailureMessage = action.res.message || '';
        dataState.clubOptionsData.result = action.res.data.result;
        dataState.clubOptionsData.region_list = action.res.data.region_list;
        dataState.clubOptionsData.tag_list = action.res.data.tag_list;
        break;

      // 店舗検索オプション取得 - 失敗
      case GET_CLUB_OPTIONS_FAILURE:
        console.log('[reservationReducer] GET_CLUB_OPTIONS_FAILURE', action.error);
        dataState.isClubOptionsLoading = false;
        dataState.isClubOptionsLoaded = false;
        dataState.clubOptionsFailureMessage = action.error?.data?.message || 'エラーが発生しました';
        dataState.clubOptionsData.result = 1;
        dataState.clubOptionsData.region_list = [];
        dataState.clubOptionsData.tag_list = [];
        break;

      // 店舗検索オプション取得 - 初期化
      case GET_CLUB_OPTIONS_INITIAL:
        console.log('[reservationReducer] GET_CLUB_OPTIONS_INITIAL');
        dataState.isClubOptionsLoading = false;
        dataState.isClubOptionsLoaded = false;
        dataState.clubOptionsFailureMessage = '';
        dataState.clubOptionsData.result = 0;
        dataState.clubOptionsData.region_list = [];
        dataState.clubOptionsData.tag_list = [];
        break;

      default:
        break;
    }
  });
};

export default reservationReducer;
